//tabla con las máquinas que tienen lecturas en una fecha determinada
//cada fila tiene un botón de editar que muestra los contadores de esa máquina para la edición de sus lecturas

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { openDialog, hideDialog } from '../../actions/index';
import { getData, postData } from '../../dataLib';
//import { modifyMaqArcade } from '../../actions/cierre_semanal_actions';
import { getDatosCierreSemanal } from '../../actions/cierre_semanal_actions';


//components:
import NeuriteGrid from '../../components/neurite_grid';
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        margin: theme.spacing(2)
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    Typography: {
        margin: 'auto'
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: 348,
        width: '100%',
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
    divTotals: {
        display: 'flex'
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class CierreSemanalLecturasArcade extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            maquinas: [],
            total: 0.0,
            descuadre: 0.0,
            showSpinner: true
        };
    };

    componentDidUpdate(prevProps) {
        if (prevProps.centroDiaSelected !== this.props.centroDiaSelected) {
            this.getMaquinas();
        }

        if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro) {
            this.setState({ ...this.state, showSpinner: true });
        }
    };

    componentDidMount = () => {
        this.getMaquinas();
    };

    calculateTotal = (rows) => {

        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(this.props.isSemanaCerrada ? r.total: r.totalSinMult);
        });
        return total;
        
    };

    getMaquinas = () => {
        getData(`VMaquinasArcade?centro_id=${this.props.centroDiaSelected.centro.id}&date=${this.props.fecha}`,
            (response) => {
                this.setState({ ...this.state, maquinas: response.data.maquinasResumenArcade, total: this.calculateTotal(response.data.maquinasResumenArcade), showSpinner: false });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching maquinas' + error
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    modificaMaquina = (maquinaId, ingresos, ingresos_sin_mult, open_next) => {

        let nextRow = undefined;

        var rows = this.state.maquinas.map((row, i) => {
            if (row.maquinaId === maquinaId) {
                if (this.state.maquinas[i + 1] !== undefined) nextRow = this.state.maquinas[i + 1];
                return { ...row, total: ingresos, totalSinMult: ingresos_sin_mult };
            }
            else return row;
        });

        this.setState({ ...this.state, maquinas: rows, total: this.calculateTotal(rows) });

        if (open_next && nextRow !== undefined) {
            this.openLecturas(nextRow);
        }
    };

    backHandler = (maquinaId) => {
        let prevRow = undefined;

        this.state.maquinas.forEach((row, i) => {
            if (row.maquinaId === maquinaId) {
                if (i > 0) prevRow = this.state.maquinas[i - 1];
            }
        });

        if (prevRow !== undefined) {
            this.props.hideDialog();
            this.openLecturas(prevRow);
        }

    }

    nextHandler = (maquinaId) => {
        let nextRow = undefined;

        this.state.maquinas.forEach((row, i) => {
            if (row.maquinaId === maquinaId) {
                if (this.state.maquinas[i + 1] !== undefined) nextRow = this.state.maquinas[i + 1];
            }
        });

        if (nextRow !== undefined) {
            this.props.hideDialog();
            this.openLecturas(nextRow);
        }

    }

    openLecturas = (maquina) => {
        this.props.openDialog(
            'CierreSemanalLecturasArcadeDetail',
            {
                maquinaId: maquina.maquinaId,
                maquinaDescr: maquina.maquina,
                maquinaRegInterno: maquina.regInterno,
                recaudacionDiaria: maquina.recaudacionDiaria,
                zonaId: maquina.zonaId,
                okHandler: this.modificaMaquina,
                backHandler: this.backHandler,
                nextHandler: this.nextHandler,
                fecha: this.props.fecha,
                tipoB: maquina.tipoB,
                tipoRegalo: maquina.iTipoRegalo
            },
            uuidv4(), true, "sm");
    };

    nuevasLecturas = () => {

        var dt = new Date(this.props.centroDiaSelected.dia);
        if (dt.getDay() === this.props.centroDiaSelected.centro.iDiaCierre) {

            const partial = (this.state.maquinas.length > 0);
            postData(

                'VMaquinasArcade/NuevasLecturas?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.fecha + '&partial=' + partial,
                (response) => {
                    this.getMaquinas();
                    this.setState({ ...this.state, showSpinner: true });
                },
                (error) => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR creando nuevas lecturas'
                    }, 'error-boton-nuevas-lecturas', false, 'sm');
                },
                {},
                this.props.user
            );
        }
        else {
            this.props.openDialog('SimpleMessage', {
                message: 'Debe seleccionar un dia de cierre semanal'
            }, 'error-boton-nuevas-lecturas-ds', false, 'sm');
        }
    }

    actualizaREDSYS = () => {

        var dt = new Date(this.props.centroDiaSelected.dia);
        if (dt.getDay() === this.props.centroDiaSelected.centro.iDiaCierre) {

            postData(

                'VMaquinasArcade/ActualizaREDSYS?centro_id=' + this.props.centroDiaSelected.centro.id + '&date=' + this.props.fecha,
                (response) => {
                    this.getMaquinas();
                    this.setState({ ...this.state, showSpinner: true });
                    this.props.getDatosCierreSemanal(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
                    // this.props.modifyMaqArcade(
                    //     this.props.zonaId,
                    //     0.0, //(this.state.total_euros * mult) - (this.state.total_euros_ini * mult),
                    //     0.0, //this.state.total_euros - this.state.total_euros_ini,
                    //     0.0, //this.state.total_tickets - this.state.total_tickets_ini,
                    //     0.0, //this.state.total_tokens - this.state.total_tokens_ini,
                    //     0.0, //this.state.total_regalos - this.state.total_regalos_ini,
                    //     1123.0, //this.state.total_visas - this.state.total_visas_ini
                    // );                
                },

                (error) => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR actualizando REDSYS'
                    }, 'error-boton-actualiza-REDSYS', false, 'sm');
                },
                {},
                this.props.user
            );
        }
        else {
            this.props.openDialog('SimpleMessage', {
                message: 'Debe seleccionar un dia de cierre semanal'
            }, 'error-boton-actualiza-REDSYS-ds', false, 'sm');
        }
    }

    render() {
        const { classes } = this.props;

        return (
            !this.state.showSpinner ?


                <div className={classes.divData}>
                    <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>
                    <NeuriteGrid
                        id="c_s_l_a"
                        columns={[
                            //{ key: 'id', name: 'id', editable: false, dragable: false },
                            { key: 'modelo', name: 'Modelo', editable: false, dragable: false, width: 160 },
                            { key: 'tipo', name: 'Tipo', editable: false, dragable: false, width: 115 },
                            { key: 'maquina', name: 'Maquina', editable: false, dragable: false, width: 160 },
                            { key: 'regInterno', name: 'RegInterno', editable: false, dragable: false, width: 90 },
                            { key: this.props.isSemanaCerrada ? 'total' : 'totalSinMult', name: 'Ingreso', tooltip: 'Ingreso real de cierre', editable: false, dragable: false, type: 'float', width: 95 },
                        ]}
                        rows={this.state.maquinas}
                        buttonEdit={true}
                        buttonDelete={false}
                        buttonNew={false}
                        onEditClick={this.openLecturas}
                        enableSelection={false}
                        enableFilter={true}
                        height={300}
                    />

                    <div className={classes.divTotals}>
                        <div className={classes.total}>
                            <p style={{ margin: 0 }}>Total</p>
                            <Tooltip title="Total ingreso real" TransitionComponent={Fade} placement="bottom" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                                <TextField
                                    id="total"
                                    disabled
                                    value={this.state.total}
                                    className={classes.input}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                    variant="outlined"
                                />
                            </Tooltip>
                        </div>
                        <Tooltip title="Añadir lecturas de máquinas que faltan o que han sido incorporadas entre cierres" TransitionComponent={Fade} placement="right" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <span>
                                <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => this.nuevasLecturas()}>
                                    Añadir lecturas
                            </Button>
                            </span>
                        </Tooltip>
                        <Tooltip title="Actualizar las lecturas con los registros de REDSYS" TransitionComponent={Fade} placement="right" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <span>
                                <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => this.actualizaREDSYS()}>
                                    Actualiza REDSYS
                            </Button>
                            </span>
                        </Tooltip>
                    </div>

                    <div className={classes.bottomBtn}>
                        {this.props.isDialog ? <Button variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.props.hideDialog() }}>Cerrar</Button> : ''}
                    </div>
                </div>

                :
                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
        );
    };
};


CierreSemanalLecturasArcade.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,

    fecha: PropTypes.object

};


function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
        getDatosCierreSemanal,
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalLecturasArcade));